import React, {createContext, useEffect, useState} from 'react';
import {iProvider} from './types';

interface IErrorContext {
  error: string;
  setError: (value: any) => void;
}

const defaultErrorContext: IErrorContext = {
  error: '',
  setError: () => null
};

export const ErrorContext = createContext<IErrorContext>(defaultErrorContext);

const ErrorProvider = ({children}: iProvider): React.ReactElement => {
  const errorDuration = 20; // In seconds
  const [error, setErrorString] = useState(defaultErrorContext.error);

  const setError = (value: any) => {
    setErrorString('' + value);
  };

  useEffect(() => {
    if (error === defaultErrorContext.error) return;

    setTimeout(() => {
      setError(defaultErrorContext.error);
    }, errorDuration * 1000);
  }, [error]);

  return <ErrorContext.Provider value={{error, setError}}>{children}</ErrorContext.Provider>;
};

export default ErrorProvider;
